import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';
import BookScholarship from '@cont/BookScholarship/BookScholarship';
import {
  fetchCityCenterMapping,
  fetchFAQs,
  fetchNonSchoolSlots,
  fetchUnsatData
} from '@cont/BookScholarship/apiHelper';
import Header from '@layout/HeaderTemplates/Base';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { getFormData } from '@cont/OfflineCentres/PostPaymentLearnerDetails/apiHelper';

const unsat = ({
  unsatData,
  dateSlots,
  nonSchoolFAQHTML,
  cityCenterMapping,
  formDetails
}) => {
  if (!unsatData) return;
  return (
    <>
      <NextSeo
        title="UNSAT - Scholarship Test to Ace IIT JEE, NEET UG and Class 9 to 12 Exams"
        description="Looking to crack IIT JEE or NEET? Attempt UNSAT scholarship test and get up to 100% scholarship at Unacademy offline centres and on online subscription."
      />
      <Header />
      <BookScholarship
        formDetails={formDetails}
        apiResponse={JSON.parse(unsatData)}
        dateSlots={dateSlots}
        nonSchoolFAQHTML={nonSchoolFAQHTML}
        cityCenterMapping={cityCenterMapping}
      />
    </>
  );
};

unsat.pageInfo = {
  layoutOptions: {
    disableDarkMode: true,
    hideHeader: true
  },
  isMWebSupported: true
};

unsat.getInitialProps = setupInitialProps(
  async ({ cookies: cookiesFromServer }) => {
    const { accessToken, refreshToken } = cookiesFromServer || {};
    let formDetails;
    if (accessToken && refreshToken) {
      try {
        formDetails = await getFormData(3, accessToken);
      } catch (error) {
        formDetails = {};
      }
    }
    const promises = [];
    promises.push(fetchUnsatData());
    promises.push(fetchNonSchoolSlots());
    promises.push(fetchFAQs());
    promises.push(fetchCityCenterMapping());

    const response = await Promise.all(promises);
    const unsatData = response[0];
    const dateSlots = response[1];
    const nonSchoolFAQHTML = response[2];
    const cityCenterMapping = response[3];
    return {
      unsatData: JSON.stringify(unsatData),
      dateSlots,
      nonSchoolFAQHTML,
      cityCenterMapping,
      formDetails
    };
  },
  unsat.pageInfo
);

unsat.Layout = Layout;
unsat.Layout.displayName = 'UNSAT';

unsat.propTypes = {
  unsatData: PropTypes.string.isRequired
};

unsat.Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default unsat;
unsat.Wrapper = PageReduxProvider;
